import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthComponent } from './oauth/oauth.component';
import { GlobalLoadingComponent } from './loading/global-loading/global-loading.component';
import { NgxHekaDesignLibModule } from 'ngx-heka-design-lib';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [OauthComponent, GlobalLoadingComponent],
  imports: [CommonModule, 
    NgxHekaDesignLibModule,
     TranslateModule,
      MatButtonModule,
       MatProgressSpinner,

        ],
  exports: []
})
export class ComponentsModule {}
